function getUrlParam(paramName) {
  let paramValue = null
  const queryString = window.location.search.slice(1)
  const paramsArray = queryString.split("&")

  for (let i = 0; i < paramsArray.length; i++) {
    const param = paramsArray[i]
    const keyValuePair = param.split("=")
    const key = keyValuePair[0]

    if (key === paramName) {
      paramValue = decodeURIComponent(keyValuePair[1])
      break
    }
  }
  return paramValue
}

function submitOptOutForm() {
  const formElement = document.getElementById("pc--opt-out-form")
  formElement.submit()
}

function showSuccessMessage() {
  const email_address = getUrlParam("email")
  const formElement = document.getElementById("pc--opt-out-form-container")
  const successMessageElement = document.getElementById("pc--opt-out-success")
  const successMessageContent = document.getElementById("pc--opt-out-success-content")
  const errorMessageElement = document.getElementById("pc--opt-out-error")

  const message = email_address
    ? "Opted-out <strong>" + email_address + "</strong> successfully"
    : "Opted-out successfully"

  successMessageContent.innerHTML = message
  successMessageElement.style.display = "flex"
  errorMessageElement.style.display = "none"
  formElement.style.display = "none"
}

function showErrorMessage() {
  const formElement = document.getElementById("pc--opt-out-form-container")
  const errorMessageElement = document.getElementById("pc--opt-out-error")
  const successMessageElement = document.getElementById("pc--opt-out-success")

  formElement.style.display = "block"
  errorMessageElement.style.display = "flex"
  successMessageElement.style.display = "none"
}

function showNotApplicableMessage() {
  const notApplicableMessageElement = document.getElementById("pc--opt-out-not-applicable")
  notApplicableMessageElement.style.display = "block"
}

function setupForm() {
  const formContainer = document.getElementById("pc--opt-out-form-container")
  formContainer.style.display = "block"

  const returnTo = document.getElementById("pc_return_to")
  returnTo.setAttribute("value", window.location.pathname)
}

function loadFeatureCallback(error) {
  if (error) {
    throw error
  }

  if (canOptOut()) {
    setupForm()
    if (getUrlParam("success") === "true") {
      showSuccessMessage()
    } else if (getUrlParam("success") === "false") {
      showErrorMessage()
    }
  } else {
    showNotApplicableMessage()
  }
}

function canOptOut() {
  const api = window.Shopify.customerPrivacy

  if (api.unstable) {
    return api.unstable.saleOfDataRegion()
  }

  return api.getRegulation() === "CCPA"
}

function ccpaOptOutLoader() {
  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1"
      }
    ],
    loadFeatureCallback
  )
}

ccpaOptOutLoader()

function optOutOnLoad() {
  const optOutForm = document.getElementById("pc--opt-out-form")
  const optOutSubmitButton = document.getElementById("pc--opt-out-button")

  optOutSubmitButton.addEventListener("click", function(e) {
    e.preventDefault()

    if (!optOutForm.reportValidity()) {
      return
    }

    if (document.getElementById("hcaptcha")) {
      hcaptcha.execute()
    } else {
      submitOptOutForm()
    }
  })
}
